import { useRoom, useSettings, useSession } from '@turnaroundfactor/react'
import React, { useRef, useEffect } from 'react'
import LocalVideo from './LocalVideo'
import PeerUser from './PeerUser'
import { GridContainer, GridItem } from '@thangdevalone/meeting-grid-layout-react'
import getLocalStream from '../../utils/getLocalStream'

// const baseCols = 5;
// const testProps = { name: 'Test Item', type: 'RemoteExpert', on: ()=> {}, off: ()=> {}, one: ()=> {}, getTracks: ()=> ([]), connected: true };
// const xtra  = [
//   { uuid: '12345', ...testProps },
//   { uuid: '67890', ...testProps },
//   { uuid: '38291', ...testProps },
//   { uuid: '35532', ...testProps },
//   { uuid: '21093', ...testProps },
//   { uuid: '19494', ...testProps },
//   { uuid: '10212', ...testProps },
//   { uuid: '21093', ...testProps },
//   { uuid: '19494', ...testProps },
//   { uuid: '10212', ...testProps }, 
//   { uuid: '10212', ...testProps } 
// ]

function TempUser({ name }) {
  return (
    <div className="peer-user position-relative" style={{ background: 'white' }}>
      <figure className={`embed-responsive embed-responsive-16x9 video`} data-testid="video" style={{ background: '#666666' }}>
        <video autoPlay playsInline style={{ background: 'white' }}></video>
        <figcaption>
          {name} 
        </figcaption>
      </figure>
    </div>
  )
}

// function getColumnCount(count, activeTool, pinned = null){
//   if ( count === 1 ) return 1;
//   if ( activeTool === 'pdf' ) return 1;
  
//   if ( pinned ) {
//     const ncount = count - 1;
//     return ( ncount <= baseCols) ? baseCols : Math.ceil(Math.sqrt(ncount));
//   }
  
//   //if ( count < baseCols ) return count; 
//   return Math.ceil(Math.sqrt(count));
// }

// function getRowCount(count, activeTool, cols, pinned){
//   if ( count <= 2 ) return 1;
//   if ( activeTool === 'pdf' ) return count;
//   if ( pinned ) {
//     return Math.round(Math.sqrt(cols));
//   }

//   return Math.ceil(Math.sqrt(cols));
// }

export default function VideoMain(){
  const { user } = useSession();
  const { users } = useRoom();
  const { settings: { activeTool, AREnabled, pinned } } = useSettings();
	const videoRef = useRef();

	// const users = xtra;
  const count = users.length + 1;
  //const count = xtra.length + 1;  
  
  
  // const cols    = getColumnCount(count, activeTool, pinned);
  // const rows    = getRowCount(count, activeTool, cols, pinned);
  const pin     = users.find(u => u.uuid === pinned)?.uuid || null;
  const hasPin  = count > 2 ? (pin != null ) : false;
  const compact = (['screenshot', 'draw'].includes(activeTool) && AREnabled) || activeTool === 'pdf';
	
	const pidx = users.findIndex(u => u.uuid === pinned);
	const pinnedIndex = pinned === null ? undefined : (pidx === -1 ? 0 : pidx + 1);
	const pippedIndex = users.length === 1 ? 0 : undefined;

  useEffect(() => {
		let mounted = true;
		getLocalStream()
			.then((stream) => {
				if (mounted && videoRef.current) {
					videoRef.current.srcObject = stream;					
				}
			})
		}, []);

  return (
    <div id="video_main">
			{/* <video ref={videoRef} autoPlay playsInline muted style={{ position: 'absolute', width: '1px', height: '1px', pointerEvents: 'none' }}></video> */}
			<GridContainer 
				id="video_grid" 
				aspectRatio="16:9" 
				gap={2} 
				layoutMode="gallery" 
				count={users.length + 1} 
				data-compact={compact} 
				disableFloat={compact}
				pipIndex={pippedIndex}
				pinnedIndex={pinnedIndex} 
				othersPosition="bottom">
					<GridItem key="local" index={0}>
						<LocalVideo />
					</GridItem>
					{ users.map((m, i) => 
					<GridItem key={m.uuid} index={i + 1} style={ compact ? { position: 'static' } : {}}>
						<PeerUser name={m.name || 'User'} uuid={m.uuid} type={m.type} />
					</GridItem>
					)}
				</GridContainer>
      {/* <div id="video_grid" style={{ '--video-count': count, '--video-cols': cols, '--video-rows': rows }} data-count={count} data-pinned={hasPin} data-compact={compact}>
        <div className={`item local ${(pinned === user.uuid) ? 'pinned' : ''}`}>
          <LocalVideo />
        </div>
        { users.map((m, i) => 
          <div className={`item ${(pin === m.uuid || (pinned === null && count <= 2)) ? 'pinned' : ''}`} key={m.uuid}>
            <TempUser {...m} />
            <PeerUser name={m.name || 'User'} uuid={m.uuid} type={m.type} />
          </div>
        )}
      </div> */}
    </div>
  );
}
